import { createContext, useContext } from 'react';
import { FormContextType, RJSFSchema } from '@rjsf/utils';
import { SchemaRegistry } from './definitions/schemaRegistry';

export type SchemaContextType = {
  schema: RJSFSchema | null;
  setSchema: (schema: RJSFSchema | null) => void;
  selectedRegistry: SchemaRegistry | null;
  setSelectedRegistry: (registry: SchemaRegistry | null) => void;
  error: string | null;
  setError: (error: string | null) => void;
  formData: FormContextType | null;
  setFormData: (data: FormContextType | null) => void;
};

export const SchemaViewerContext = createContext<SchemaContextType | undefined>(undefined);

export const useSchemaViewerContext = () => {
  const context = useContext(SchemaViewerContext);
  if (context === undefined) {
    throw new Error('useSchemaViewerContext must be used within a SchemaProvider');
  }
  return context;
};